var Buf = require('buf');
var Channel = require('channel');
var Child = require('child');
var ConnectionBufferList = require('connectionbufferlist');
var Conversation = require('conversation');
var Ignore = require('ignore');
var Message = require('message');
var PrefMixins = require('prefmixins');
var ServerLog = require('serverlog');
var User = require('user');
var sko = require('../lib/safekeyobject.es6').default;
var twitch = require('../lib/twitch.es6');
var util = require('../lib/util.es6');
var startSlackAuth = require('../lib/slack.es6').startAuth;


var Connection = Backbone.Model.extend($.extend({}, PrefMixins, {
    idAttribute: 'cid',
    initialize: function (data, options) {
        this.session = options.session;
        options.connection = this;
        this.user = new User(data, options);

        this.buffers = new ConnectionBufferList(null, {connection: this});
        this.buffers.on('change:archived', this.onBufferArchiveChange, this);

        this.disambiguation = 0;
        this.serverLog = null;
        this.isupport = {};
        this.usermodes = "";
        this.reloading = false;

        this.inputHistory = new sko();

        this.parseIgnores();

        this.setHostnameTests();

        this.initialized = false;

        this.bind('change:name', this.urlChange, this);
        this.bind('change:hostname', this.urlChange, this);
        this.bind('change:port', this.urlChange, this);
        this.bind('change:ssl', this.urlChange, this);
        this.bind('change:hostname', this.setHostnameTests, this);
        this.bind('change:ircserver', this.setHostnameTests, this);
        this.bind('change:avatar', this.avatarChange, this);
        this.bind('change:avatar_url', this.avatarChange, this);
        this.bind('change', this.updateUser, this);

        PrefMixins.initialize.apply(this, arguments);
    },
    isOrgServer: function () {
        return !!this.get('orgid');
    },
    getOrg: function () {
        var orgid = this.get('orgid');
        if (orgid) {
            return this.session.orgs.get(orgid);
        }
    },
    setOrder: function (order, options) {
        this.set('order', order, options);
    },
    getOrder: function () {
        return this.get('order') || this.getCid();
    },
    move: function (up) {
        this.collection.move(this, up);
    },
    getUser: function () {
        return this.user;
    },
    getPrefKey: function (key) {
        return 'connection-' + key;
    },
    prefKeys: {
        'avatars-disableUploadPrompt': ['avatars-enableUploadPrompt', true],
        'reply-collapse': ['reply-expand', false],
        'reply-quote': ['reply-noquote', false],
    },
    isIgnored: function (nick, hostmask, options) {
        options = options || {};
        if (nick || hostmask) {
            nick = nick || '*';
            hostmask = hostmask || '*';
            if (_.contains(nick, '@')) {
                debug.warn('Nick contains @: ' + nick);
            }
            var check = Ignore.check(nick + '!' + hostmask, this.ignoreMap);
            if (options.returnMap) {
                var masks = [check.nick + '!' + check.user + '@' + check.host];
                if (check.user == '*') {
                    masks.push(check.nick + '!' + check.host);
                    if (check.host == '*') {
                        masks.push(check.nick);
                    }
                } else if (check.nick == '*') {
                    masks.push(check.user + '@' + check.host);
                }
                check.masks = masks;
                return check;
            } else {
                return check.match;
            }
        }
        if (options.returnMap) {
            return {match: false};
        } else {
            return false;
        }
    },
    getIgnores: function () {
        return this.get('ignores') || [];
    },
    parseIgnores: function () {
        var parsed = Ignore.parse(this.getIgnores());
        if (!_.isEqual(parsed, this.ignoreMap)) {
            this.ignoreMap = parsed;
            this.trigger('ignoresChange');
        }
    },
    setIgnores: function (ignores) {
        // Stream response when ignore is changed (used when updated in a separate client)
        ignores.sort();
        this.set({ignores: ignores});
        this.parseIgnores();
    },
    saveIgnores: function (ignores) {
        // Update made through the JS API
        this.setIgnores(ignores);

        this.post('set-ignores', {
            ignores: JSON.stringify(ignores)
        });
    },
    isReloading: function () {
        return this.reloading;
    },
    reload: function (message) {
        this.reloading = true;
        this.set(message);
    },
    doneReload: function () {
        this.reloading = false;
        this.trigger('reload');
    },
    avatarChange: function () {
        var org = this.getOrg();
        if (org) {
            org.set('avatar', this.get('avatar'));
        }
    },
    updateUser: function () {
        this.user.set(this.attributes);
    },
    urlChange: function () {
        this.trigger('urlPropChange', this);
    },
    setServerLog: function (serverLog) {
        this.addBuffer(serverLog);
        this.serverLog = serverLog;
        // For newly created connections
        if (this.session.isInitialized()) {
            this.init();
        }
    },
    getIdKeys: function () {
        // For fuzzy url shortcut matching
        var keys = [
            this.getId(),       // Full ID including disambiguation
            this.getHostname(), // w/o port e.g. irc.foo.com
            this.getHost()      // w/ port e.g. irc.foo.com:6667
        ];
        if (this.isSSL()) {
            keys.push(this.getHostname(true)); // w/o port w/ protocol e.g. ircs://irc.foo.com
            keys.push(this.getHost(true));     // w/ port w/ protocol e.g. ircs://irc.foo.com:6697
        }
        if (this.isIRCSubdomain()) {
            keys.push(this.getHostname().replace(/^irc\./, ''));
        }
        return keys;
    },
    isIRCSubdomain: function (label) {
        label = label || this.getHostname();
        return /^irc\./.test(label);
    },
    buildDisambiguation: function (disambiguation) {
        if (disambiguation) {
            return ':' + disambiguation;
        }
        return '';
    },
    getDisambiguation: function () {
        return this.buildDisambiguation(this.disambiguation);
    },
    setDisambiguation: function (disambiguation) {
        this.disambiguation = disambiguation;
        this.trigger('disambiguationChange', this);
    },
    isSSL: function () {
        return this.get('ssl');
    },
    isSuspiciousPort: function () {
        return (this.isSSL() && this.getPort() == Connection.defaultPort) ||
              (!this.isSSL() && this.getPort() == Connection.defaultSSLPort);
    },
    hasSpam: function () {
        return this.buffers.hasSpam();
    },
    isSuspiciousHostname: function () {
        var hostname = this.get('hostname');
        return (hostname[0] == '.') ||
               (hostname[hostname.length - 1] == '.') ||
               (hostname.indexOf('.') == -1 && hostname.indexOf(':') == -1);
    },
    isTeamServer: function () {
        if (this.get('team_server')) {
            return true;
        }
        if (this.session.ent('unixname') == this.get('hostname')) {
            return true;
        }
        return false;
    },
    getPort: function () {
        return this.get('port');
    },
    // Includes port
    getHost: function (withSSL) {
        var host = this.getHostname(withSSL);
        if (this.has('port')) {
            host += ':' + this.getPort();
        }
        return host;
    },
    // Without port
    getHostname: function (withSSL) {
        var hostname = '';
        if (withSSL && this.isSSL()) {
            hostname += 'ircs://';
        }
        hostname += this.get('hostname').toLowerCase();
        return hostname;
    },
    getNetworkId: function () {
        return this.getSlug();
    },
    getEncodedNetworkId: function () {
        return encodeURIComponent(this.getSlug());
    },
    url: function () {
        return this.buildUrl();
    },
    urlId: function () {
        return this.buildUrlId();
    },
    userUrl: function () {
        return this.buildUrl(['messages', this.getNick()]);
    },
    urlRoot: function () {
        return this.getEncodedNetworkId() + this.getDisambiguation();
    },
    getId: function () {
        return this.getNetworkId() + this.getDisambiguation();
    },
    buildUrl: function (parts) {
        return Connection.buildUrl(this.urlRoot(), parts);
    },
    buildUrlId: function (namespace, label) {
        return this.joinUrlParts([namespace, label]);
    },
    joinUrlParts: function (parts) {
        return Connection.joinUrlParts(this.urlRoot(), parts);
    },
    buildId: function (namespace, label) {
        return Connection.buildId(Connection.buildId(this.getId(), namespace), label);
    },
    channelSlug: function (name) {
        name = name.toLowerCase();
        var stripped = name.replace(/^#/, '');
        if (stripped != this.normaliseBufferName(stripped)) {
            stripped = name;
        }
        return stripped;
    },
    testId: function (disambiguation) {
        return this.getNetworkId() + this.buildDisambiguation(disambiguation);
    },
    normaliseBufferName: function (bufferName) {
        return util.normaliseChan(bufferName, this.getChannelPrefixes());
    },
    getCid: function () {
        return this.get('cid');
    },
    bindMessages: function () {
        this.listenTo(this.session, 'connectionMessage:' + this.getCid(), this.handleMessage);
        this.listenTo(this.session, 'connectionResponse:' + this.getCid(), this.handleResponse);
    },
    getBuffer: function (bid) {
        return this.buffers.get(bid);
    },
    isBacklogLoaded: function () {
        return this.isInitialized() && !this.isReloading();
    },
    triggerInitializedMessageEvent: function (message) {
        if (this.isBacklogLoaded()) {
            this.trigger('message:' + message.type, message);
        }
    },
    handleMessage: function (message) {
        if (this.messageHandlers[message.type]) {
            this.messageHandlers[message.type].call(this, message);
        }
        if (this.isBacklogLoaded() && this.initializedMessageHandlers[message.type]) {
            this.initializedMessageHandlers[message.type].call(this, message);
        }
        if (message.bid && message.bid > 0) {
            var buffer = this.getBuffer(message.bid);
            if (buffer) {
                buffer.addMessage(message);
            }
        } else if (this.serverLog) {
            this.serverLog.triggerInitializedMessageEvent(message);
        }
        this.triggerInitializedMessageEvent(message);
    },
    handleResponse: function (response, request) {
        if (this.responses[response.type]) {
            this.responses[response.type].call(this, response, request);
        }
    },
    setFocusOnMakeBuffer: function (name) {
        if (name) {
            clearTimeout(this.focusOnMakeBufferTimeout);
            this.focusOnMakeBuffer = name.toLowerCase();
            var buffer;
            if (this.focusOnMakeBuffer == '*') {
                buffer = this.buffers.getFirstBuffer() || this.serverLog;
            } else {
                buffer = this.findBuffer(this.focusOnMakeBuffer);
            }
            if (buffer) {
                this.checkFocusOnMakeBuffer(buffer);
            } else {
                this.focusOnMakeBufferTimeout = setTimeout(_.bind(function () {
                    this.setFocusOnMakeBuffer();
                }, this), 10000);
            }
        } else {
            this.focusOnMakeBuffer = null;
        }
        this.trigger('focusOnMakeBufferChange');
    },
    checkFocusOnMakeBuffer: function (buffer) {
        var select;
        if (this.focusOnMakeBuffer == '*') {
            // Star means select the first non server log buffer we get
            if (buffer.getName() == '*') {
                // Do select the server log, but don't clear the focus
                buffer.select({automatic: true});
            } else {
                select = buffer;
            }
        } else if (buffer.checkFocusOnMakeBufferName(this.focusOnMakeBuffer)) {
            select = buffer;
        }
        if (select) {
            select.select();
        }
    },
    isInitialized: function () {
        return this.initialized;
    },
    select: function () {
        this.doSelectOrWaitForMakeBuffer(this.serverLog, "*");
    },
    isSelected: function () {
        return this.equals(this.session.currentBuffer);
    },
    responses: {
        open_buffer: function (response, request) {
            if ((
                request._method == 'say' ||
                request._method == 'reply' ||
                request._method == 'react'
            ) && request.to == response.name) {
                // Saying to the buffer directly, e.g. via user.say/buffer.say or connection.openBuffer
                // meaning we already handle selection if needed
                return;
            } else {
                this.selectOrWaitForMakeBuffer(response.name);
            }
        }
    },
    selectOrWaitForMakeBuffer: function (name) {
        var buffer = this.findBuffer(name, true);
        this.doSelectOrWaitForMakeBuffer(buffer, name);
    },
    doSelectOrWaitForMakeBuffer: function (buffer, name) {
        if (buffer) {
            buffer.select();
        } else {
            this.setFocusOnMakeBuffer(name);
        }
    },
    isChannelName: function (name) {
        if (!name) {
            return false;
        }
        return _.include(this.getChannelPrefixes(), name[0]);
    },
    makeChild: function (data) {
        var name = data.name || data.chan;
        if (name) {
            if (this.isChannelName(name)) {
                return this.makeChannel(data);
            } else {
                return this.makeConversation(data);
            }
        } else {
            return this.makeServerLog(data);
        }
    },
    makeChannel: function (data) {
        return new Channel(data, {
            connection: this,
            session: this.session
        });
    },
    makeConversation: function (data) {
        return new Conversation(data, {
            connection: this,
            session: this.session
        });
    },
    makeServerLog: function (data) {
        return new ServerLog(data, {
            connection: this,
            session: this.session
        });
    },
    messageHandlers: {
        makebuffer: function (message) {
            var buffer = this.getBuffer(message.bid);
            if (buffer) {
                // Already created
                buffer.setLastSeen(message.last_seen_eid);
                buffer.set(message);
            } else {
                switch (message.buffer_type) {
                case 'console':
                    this.setServerLog(this.makeServerLog(message));
                    break;
                case 'channel':
                    this.addBuffer(this.makeChannel(message));
                    break;
                case 'conversation':
                    this.addBuffer(this.makeConversation(message));
                    break;
                }
            }
        },
        isupport_params: function (message) {
            this.setISupport(message.params);
            this.setUsermodes(message.usermodes);
            this.setVersion(message.version);
        },
        myinfo: function (message) {
            this.setMyInfo({
                server: message.server,
                version: message.version,
                user_modes: message.user_modes,
                channel_modes: message.channel_modes,
                rest: message.rest
            });
            this.setVersion(message.version);
            this.set({ircserver: message.server});
        },
        end_of_backlog: function (message) {
            if (this.isReloading()) {
                // setLastSeen is called in makebuffer before messages
                // are received, so we need to reset it here after they've
                // all come through
                this.buffers.each(function (buffer) {
                    buffer.resetLastSeen();
                });
                this.doneReload();
            } else if (!this.isInitialized() && this.serverLog) {
                this.init();
            }
        }
    },
    initializedMessageHandlers: {
        notice: function (message) {
            if (!this.serverLog || message.bid != this.serverLog.id) {
                // Only server log messages
                return;
            }
            if ('server' in message) {
                var chan = Message.checkThrottleChan(message.msg);
                var buffer = this.findChannel(chan);
                if (buffer) {
                    buffer.trigger('throttleMessage');
                }
            }
        },
        server_details_changed: function (message) {
            this.set(message);
        },
        set_ignores: function (message) {
            this.setIgnores(message.masks);
        },
        self_details: function (message) {
            var props = {};
            if (message.server_realname) {
                props.server_realname = message.server_realname;
            }
            if (message.usermask) {
                props.ident_prefix = message.ident_prefix;
                props.user = message.user;
                props.userhost = message.userhost;
                props.usermask = message.usermask;
            }
            this.propagateUserProps(this.getNick(), props, true);
        },
        avatar_change: function (message) {
            this.propagateUserProps(message.nick, {
                avatar: message.avatar,
                avatar_url: message.avatar_url
            }, message.self);
        },
        display_name_change: function (message) {
            this.propagateUserProps(message.nick, {
                display_name: message.display_name
            }, message.self);
        },
        status_text_change: function (message) {
            this.propagateUserProps(message.nick, {
                status_text: message.status_text
            }, message.self);
        },
        pronouns_change: function (message) {
            this.propagateUserProps(message.nick, {
                pronouns: message.pronouns
            }, message.self);
        },
        bot_url_change: function (message) {
            this.propagateUserProps(message.nick, {
                bot_url: message.bot_url
            }, message.self);
        },
        cap_change: function (message) {
            var values = message.cap_values || this.get('cap_values');
            this.set({
                caps: message.caps,
                cap_values: values,
                avatars_supported: message.avatars_supported
            });
        },
        you_nickchange: function (message) {
            this.set({nick: message.newnick});
        },
        channel_renamed: function (message) {
            if (this.focusOnMakeBuffer === message.old_chan.toLowerCase() || this.findChannel(message.old_chan)) {
                var buffer = this.findChannel(message.new_chan);
                if (buffer) {
                    buffer.select();
                } else {
                    this.setFocusOnMakeBuffer();
                }
            }
        },
        link_channel: function (message) {
            if (message.invalid_chan && this.focusOnMakeBuffer === message.invalid_chan.toLowerCase() || this.findChannel(message.invalid_chan)) {
                var buffer = this.findChannel(message.valid_chan);
                if (buffer) {
                    buffer.select();
                } else {
                    this.setFocusOnMakeBuffer();
                }
            }
        },
        // From whois/PM
        away: function (message) {
            // TODO we need to track this server side and return it in makebuffer
            if (message.self) {
                this.setAway(message.msg);
            }
            var conversation = this.findConversation(message.nick);
            if (conversation) {
                conversation.setAway(message.msg);
            }
        },
        logged_in_as: function (message) {
            this.set('account', message.name);
        },
        hidden_host_set: function (message) {
            var props = {
                userhost: message.hidden_host
            };
            if (message.hidden_mask) {
                props.usermask = message.hidden_mask;
            }
            if (message.user) {
                props.user = message.user;
            }
            if (message.ident_prefix) {
                props.ident_prefix = message.ident_prefix;
            }
            this.propagateUserProps(
                this.getNick(), props, true
            );
        },
        whois_response: function (message) {
            // Set certain properties from response
            var props = {};
            if (message.server_addr) {
                props.ircserver = message.server_addr;
            }
            if (message.user_realname) {
                props.realname = message.user_realname;
            }
            if (message.user_ident_prefix) {
                props.user = message.user_username;
                props.usermask = message.user_mask;
                props.userhost = message.user_host;
                props.ident_prefix = message.user_ident_prefix;
            } else if (message.user_host) {
                // ident_prefix and mask weren't always available
                props.user = message.user_username.replace(/^~/, '');
                props.usermask = message.user_username + '@' + message.user_host;
                props.userhost = message.user_host;
                props.ident_prefix = message.user_username.indexOf('~') === 0 ? '~' : '';
            }
            this.propagateUserProps(message.nick, props);
        },
        user_account: function (message) {
            this.propagateUserProps(message.nick, {
                // needs a value or else it won't override
                account: message.account || '*'
            }, message.self);
        },
        user_realname: function (message) {
            this.propagateUserProps(message.nick, {
                realname: message.realname,
                server_realname: message.server_realname
            }, message.self);
        },
        user_mode: function (message) {
            var userMode = message.newmode;
            if (userMode) {
                userMode = '+' + userMode;
            }
            this.set('user_mode', userMode);
        },
        user_away: function (message) {
            var nick = message.nick;
            if (message.self) {
                this.setAway(message.msg);
            }
            // Propagate to existing buffers
            var conversation = this.findConversation(nick);
            if (conversation) {
                conversation.setAway(message.msg);
            }
            this.buffers.channels.each(function (ch) {
                var member = ch.getMember(nick);
                if (member) {
                    member.setAway(message.msg);
                }
            });
        },
        user_back: function (message) {
            var nick = message.nick;
            if (message.self) {
                this.setBack();
            }
            // Propagate to existing buffers
            var conversation = this.findConversation(nick);
            if (conversation) {
                conversation.setBack();
            }
            this.buffers.channels.each(function (ch) {
                var member = ch.getMember(nick);
                if (member) {
                    member.setBack();
                }
            });
        },
        self_away: function (message) {
            this.setAway(message.away_msg);
        },
        self_back: function (message) {
            this.setBack();
        },

        // Connection status
        status_changed: function (message) {
            var fail = message.fail_info;
            var status = message.new_status;
            var currentFail = this.get('fail_info');
            if (
                // Don't overwrite fail_info on ip_retry
                (!$.isEmptyObject(currentFail) && status == 'ip_retry')
                // Don't wipe fail_info on queued or connecting
                || ($.isEmptyObject(fail) && (status == 'queued' || status == 'connecting'))) {
                fail = currentFail;
            }
            var props = {
                status: status,
                fail_info: fail
            };
            if (message.nick) {
                props.nick = message.nick;
            }
            this.set(props);
            if (this.isDisconnected() || this.isStatus('connected')) {
                this.resetDetails();
            }
        }
    },
    findUser: function (nick) {
        var u;
        this.buffers.channels.find(function (ch) {
            u = ch.getMember(nick);
            if (u) {
                return true;
            }
        });
        return u;
    },
    findUserProps: function (nick) {
        var u = this.findUser(nick);
        if (u) {
            return u.attributes;
        }
    },
    propagateUserProps: function (nick, props, self) {
        if (self) {
            this.set(props);
        }
        // Propagate to existing buffers
        var conversation = this.findConversation(nick);
        if (conversation) {
            conversation.setRecipientProps(props);
        }
        this.buffers.channels.each(function (ch) {
            var member = ch.getMember(nick);
            if (member) {
                member.set(props);
            }
        });
    },
    resetDetails: function () {
        this.set({
            'away': '',
            'ident_prefix': '',
            'user': '',
            'userhost': '',
            'usermask': '',
            'account': '',
            'server_realname': '',
            'caps': [],
            'avatars_supported': false,
            'avatar_url': '',
            'display_name': '',
            'status_text': '',
            'pronouns': '',
            'bot_url': '',
            'user_mode': '',
        });
    },
    init: function () {
        this.initialized = true;
        this.trigger('preinit', this);
        this.trigger('init', this);
        this.setupTwitch();
    },
    getTwitchChanNames: function () {
        if (!this.isTwitch()) {
            return [];
        }
        return _.invoke(this.buffers.channels.filter(function (chan) {
            return !chan.isTwitchRoom();
        }, this), 'normalise');
    },
    setupTwitch: function () {
        if (this.isTwitch() && !this.twitchChannelInfo) {
            this.twitchChannelInfo = {};
            this.throttledTwitchPoll = _.throttle(_.bind(this.doPollTwitch, this), 2000);
            this.pollTwitch();
        }
    },
    getTwitchOAuth: function () {
        return (this.get('server_pass') || '').replace(/^oauth:/, '');
    },
    doPollTwitch: function () {
        twitch.fetchStreamInfo(
            this.session,
            this.getTwitchChanNames(),
            this.getTwitchOAuth()
        ).then(_.bind(function pollTwitchChannelInfo (info) {
            if (!info) {
                return;
            }
            var previousTwitchChannelInfo = $.extend(true, {}, this.twitchChannelInfo);
            this.twitchChannelInfo = info;
            _.each(info, function pollTwitchEachStream (chanInfo, channel) {
                if (previousTwitchChannelInfo[channel]) {
                    if (_.isEqual(chanInfo, previousTwitchChannelInfo[channel])) {
                        delete previousTwitchChannelInfo[channel];
                    }
                } else {
                    previousTwitchChannelInfo[channel] = undefined;
                }
            }, this);
            if (!_.isEmpty(previousTwitchChannelInfo)) {
                _.each(previousTwitchChannelInfo, function pollTwitchEachPreviousValueStream (previousValue, channel) {
                    var chan = this.findChannel('#' + channel);
                    if (chan) {
                        chan.trigger('twitchChannelChange', chan, previousValue);
                    }
                    if (info[channel] && info[channel].rooms) {
                        _.each(info[channel].rooms, function pollTwitchEachRoomChange (room) {
                            var roomChan = this.findChannel(
                                twitch.roomChannel(room.owner_id, room._id)
                            );
                            if (roomChan) {
                                roomChan.trigger('twitchChannelChange', roomChan);
                            }
                        }, this);
                    }
                }, this);
                this.trigger('twitchChannelChange', this);
            }
        }, this));
    },
    pollTwitch: function () {
        this.throttledTwitchPoll();
        setTimeout(_.bind(this.pollTwitch, this), 60000);
    },
    getTwitchChannelInfo: function (buffer) {
        if (this.twitchChannelInfo) {
            var channelName = buffer.normalise();
            return this.twitchChannelInfo[channelName];
        }
    },
    equals: function (cid) {
        if (cid instanceof Connection || cid instanceof Buf) {
            cid = cid.getCid();
        }
        return this.getCid() == cid;
    },
    addBuffer: function (buffer) {
        var name = buffer.getName();
        if (this.inputHistory.get(name)) {
            buffer.setInputHistory(this.inputHistory.get(name));
            this.inputHistory.unset(name);
        }
        this.session.addPinnedBuffer(buffer);
        this.buffers.add(buffer);
        this.checkFocusOnMakeBuffer(buffer);
    },
    removeChildren: function () {
        this.buffers.each(function (buffer) {
            if (!buffer.isServerLog()) {
                this.removeBuffer(buffer);
            }
        }, this);
    },
    removeBuffer: function (buffer) {
        // Make sure we have a buffer, this can take a bid
        buffer = this.getBuffer(buffer);
        if (buffer) {
            this.trigger('beforeBufferRemove', buffer);
            this.buffers.remove(buffer);
            buffer.stopListening();
        }
    },
    getTitle: function () {
        return this.getName();
    },
    onBufferArchiveChange: function (buffer) {
        if (buffer.isDeferred()) {
            this.decrementDeferredArchives();
        }
    },
    hasDeferredArchives: function () {
        return this.get('deferred_archives') > 0;
    },
    decrementDeferredArchives: function () {
        var deferred = this.get('deferred_archives');
        if (deferred > 0) {
            this.set('deferred_archives', deferred - 1);
        }
    },
    isFetchingArchives: function () {
        return !!this.fetchingArchives;
    },
    fetchArchives: function (callback) {
        this.fetchingArchives = true;
        return this.session.backend.get('archives', {
            cid: this.getCid()
        }, _.bind(function (response) {
            if (response.error || response.success === false) {
                this.fetchingArchives = false;
                this.trigger('archiveFetchFailed', response);
            } else {
                var buffersToAdd = _.map(response, function (message) {
                    var buffer;
                    switch (message.buffer_type) {
                    case 'channel':
                        buffer = this.makeChannel(message);
                        break;
                    case 'conversation':
                        buffer = this.makeConversation(message);
                        break;
                    }

                    var name = buffer.getName();
                    if (this.inputHistory.get(name)) {
                        buffer.setInputHistory(this.inputHistory.get(name));
                        this.inputHistory.unset(name);
                    }

                    return buffer;
                }, this);
                this.buffers.add(buffersToAdd);
                this.set('deferred_archives', false);
                this.fetchingArchives = false;
                this.trigger('archivesFetched');
                _.each(buffersToAdd, function (buffer) {
                    this.checkFocusOnMakeBuffer(buffer);
                }, this);
            }
            callback(response);
        }, this));
    },
    hasArchivedBuffers: function () {
        return this.buffers.hasArchivedBuffers();
    },
    isWhitelisted: function () {
        return $.inArray(this.getHostname(), Connection.whitelist) !== -1;
    },
    setIsTwitch: function () {
        this._isTwitch = /\.twitch\.tv$/.test(this.getHostname());
    },
    setHostnameTests: function () {
        this.setIsSlack();
        this.setIsTwitch();
    },
    setIsSlack: function () {
        this._isSlackHost = /\.slack\.com$/.test(this.getHostname());
        this._isSlackServer = /\.slack\.com$/.test(this.get('ircserver'));
    },
    isTwitch: function () {
        // Disable twitch
        return false;
        // return this._isTwitch;
    },
    isSlack: function () {
        return this.isSlackOAuth() || this._isSlackHost || this._isSlackServer;
    },
    isSlackUpgradable: function () {
        return this.session.isSlackOauthAllowed() && this.isSlack() && !this.isSlackOAuth();
    },
    isSlackOAuth: function () {
        return !!this.get('slack');
    },
    upgradeSlack: function () {
        if (this.isSlackUpgradable()) {
            startSlackAuth(this.session, {
                data: {
                    cid: this.id
                },
                onSuccess: _.bind(function (response) {
                    this.session.setFocusOnMakeServer(response.cid);
                }, this),
                onError: _.bind(function (message) {
                    if (message) {
                        this.trigger('postError', {
                            message: message
                        });
                    }
                }, this)
            });
        }
    },
    getSlackBaseUrl: function () {
        var slackMatches = this.getHostname().match(/^([^.]+).*\.slack\.com$/);
        if (!slackMatches) {
            slackMatches = this.get('ircserver').match(/^([^.]+).*\.slack\.com$/);
        }
        if (slackMatches) {
            return 'https://' + slackMatches[1] + '.slack.com/';
        }
    },
    clientTagDeny: function (tagname) {
        var denyList = this.getISupport('CLIENTTAGDENY');
        if (!denyList || !_.isString(denyList)) {
            return false;
        }
        var denied = false;
        _.each(denyList.split(','), function (tag) {
            if (tag === '*' || tag === tagname) {
                denied = true;
            }
            if (tag === ('-' + tagname)) {
                denied = false;
            }
        });
        return denied;
    },
    hasReliableClientTags: function () {
        return this.hasClientTags() && this.hasLabel();
    },
    blocksTyping: function () {
        return this.clientTagDeny('typing');
    },
    blocksReplies: function () {
        return this.clientTagDeny('reply') && this.clientTagDeny('draft/reply');
    },
    blocksReactions: function () {
        return this.blocksReplies() || this.clientTagDeny('draft/react');
    },
    blocksEdits: function () {
        return this.clientTagDeny('draft/edit') || this.clientTagDeny('draft/edit-text');
    },
    blocksDeletes: function () {
        return this.clientTagDeny('draft/delete');
    },
    hasClientTags: function () {
        return _.include(this.get('caps'), "message-tags");
    },
    hasLabel: function () {
        return (
            _.include(this.get('caps'), "labeled-response") ||
            _.include(this.get('caps'), "draft/labeled-response")
        );
    },
    hasMetadata: function () {
        return (
            _.include(this.get('caps'), "draft/metadata-2") ||
            _.include(this.get('caps'), "draft/metadata-notify-2")
        );
    },
    hasMultiline: function () {
        return _.include(this.get('caps'), "draft/multiline");
    },
    hasRedaction: function () {
        return _.include(this.get('caps'), "draft/message-redaction");
    },
    shouldGuessAvatar: function () {
        if (this.session.ent()) {
            return false;
        }
        if (this.get('avatars_supported')) {
            return false;
        }
        return true;
    },
    nativeAvatarUploadsSupported: function () {
        return (this.get('avatar') || this.get('avatars_supported'))
            && !!this.get('ircserver')
            && !this.isSlackOAuth();
    },
    avatarUploadsSupported: function () {
        if (this.nativeAvatarUploadsSupported()) {
            return true;
        }
        if (this.session.get('avatar') && !this.isSlack()) {
            return true;
        }
        return false;
    },
    setPromptAvatarPref: function (enable) {
        this.setOverridePref(enable, 'avatars-disableUploadPrompt');
    },
    setCollapsingRepliesPref: function (enable) {
        this.setOverridePref(enable, 'reply-collapse');
    },
    setQuoteRepliesPref: function (enable) {
        this.setOverridePref(enable, 'reply-quote');
    },
    isCollapsingReplies: function () {
        return this.checkPref('reply-collapse');
    },
    isShowingQuoteReplies: function () {
        return this.checkPref('reply-quote');
    },
    getRelayBots: function () {
        return this.getPref('relaybot-whitelist') || [];
    },
    setRelayBots: function (bots) {
        this.setPref('relaybot-whitelist', bots);
    },
    isRelayBot: function (nick) {
        var bots = this.getRelayBots();
        return _.contains(bots, nick);
    },
    setRelayBot: function (nick) {
        var bots = this.getRelayBots();
        var newBots = _.unique(bots.concat([nick]));
        this.setRelayBots(newBots);
    },
    unsetRelayBot: function (nick) {
        var bots = this.getRelayBots();
        var newBots = _.unique(_.without(bots, nick));
        this.setRelayBots(newBots);
    },
    hasMeaningfulHostnames: function () {
        return !this.isTwitch() && !this.isSlack();
    },
    hasUModeR: function () {
        return !this.isTeamServer() && !this.isTwitch() && !this.isSlack();
    },
    getNick: function () {
        return this.get('nick');
    },
    getName: function () {
        return this.get('name') || this.get('hostname');
    },
    getSlug: function () {
        return this.getName().toLowerCase().replace(/[_:\s]/g, '-').replace(/^irc\./, '');
    },
    getDisplayName: function () {
        return this.getName();
    },
    getFullLabel: function () {
        var name = this.getName();
        var host = this.getHost();
        if (name) {
            if (host) {
                return name + ' (' + host + ')';
            } else {
                return name;
            }
        } else {
            return host;
        }
    },
    nick: function (nick, callback) {
        return this.post('nick', {nick: nick}, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    channelBanList: function (channelName, callback) {
        return this.channelMaskModeList(channelName, 'b', callback);
    },
    channelBan: function (channelName, mask, callback) {
        return this.channelMaskModeOn(channelName, 'b', mask, callback);
    },
    channelUnban: function (channelName, mask, callback) {
        return this.channelMaskModeOff(channelName, 'b', mask, callback);
    },
    channelExceptList: function (channelName, callback) {
        return this.channelMaskModeList(channelName, 'e', callback);
    },
    channelExcept: function (channelName, mask, callback) {
        return this.channelMaskModeOn(channelName, 'e', mask, callback);
    },
    channelUnexcept: function (channelName, mask, callback) {
        return this.channelMaskModeOff(channelName, 'e', mask, callback);
    },
    channelMaskModeList: function (channelName, mode, callback) {
        // TODO make this a web service so we don't need to construct the call
        return this.say({
            msg: '/mode ' + channelName + ' +' + mode
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    channelMaskModeOn: function (channelName, mode, mask, callback) {
        // TODO make this a web service so we don't need to construct the call
        return this.say({
            msg: '/mode ' + channelName + ' +' + mode + ' ' + mask
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    channelMaskModeOff: function (channelName, mode, mask, callback) {
        // TODO make this a web service so we don't need to construct the call
        return this.say({
            msg: '/mode ' + channelName + ' -' + mode + ' ' + mask
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    prefillInputHistory: function (bufferName, message) {
        bufferName = bufferName.toLowerCase();
        if (!this.inputHistory.get(bufferName)) {
            this.inputHistory.set(bufferName, []);
        }
        this.inputHistory.get(bufferName).push({msg: message});
    },
    sayPaste: function (data, callback) {
        return this._say('say-paste', data, callback);
    },
    say: function (data, callback) {
        return this._say('say', data, callback);
    },
    react: function (data, callback) {
        return this._say('react', data, callback);
    },
    typing: function (data, callback) {
        return this._say('typing', data, callback);
    },
    reply: function (data, callback) {
        return this._say('reply', data, callback);
    },
    deleteMessage: function (data, callback) {
        return this._say('delete-message', data, callback);
    },
    redactMessage: function (data, callback) {
        return this._say('redact-message', data, callback);
    },
    editMessage: function (data, callback) {
        return this._say('edit-message', data, callback);
    },
    _say: function (endpoint, message, callback) {
        return this.post(endpoint, $.extend({
            to: '*'
        }, message), _.bind(function (response) {
            if (callback) {
                callback(response);
            } else {
                if (!response.success) {
                    this.trigger('postError', response);
                }
            }
        }, this));
    },
    post: function (method, message, callback) {
        return this.session.post(method, $.extend({
            cid: this.getCid()
        }, message), callback);
    },
    getServerIcon: function () {
        return this.getISupport('ICON') || this.getISupport('draft/ICON');
    },
    getUserModeHierarchy: function () {
        var modes = this.usermodes;
        if (modes) {
            var ownerLetter = this.getISupport('OWNER');
            return _.map(modes, function (mode) {
                if (mode == ownerLetter) {
                    return 'OWNER';
                } else if (ownerLetter && User.defaultModes[mode] == 'OWNER') {
                    return mode;
                } else if (mode == mode.toUpperCase()) {
                    if (_.includes(modes, mode.toLowerCase())) {
                        return mode;
                    } else {
                        return User.defaultModes[mode.toLowerCase()] || mode;
                    }
                } else {
                    return User.defaultModes[mode] || mode;
                }
            });
        } else {
            return User.defaultModeHierarchy;
        }
    },
    getUserModes: function () {
        var modes = this.usermodes;
        if (modes) {
            var prefixModes = {};
            var ownerLetter = this.getISupport('OWNER');
            _.each(modes, function (mode) {
                if (mode == ownerLetter) {
                    prefixModes.OWNER = mode;
                } else if (ownerLetter && User.defaultModes[mode] == 'OWNER') {
                    prefixModes[mode] = mode;
                } else if (mode == mode.toUpperCase()) {
                    if (_.includes(modes, mode.toLowerCase())) {
                        prefixModes[mode] = mode;
                    } else {
                        prefixModes[User.defaultModes[mode.toLowerCase()] || mode] = mode;
                    }
                } else {
                    prefixModes[User.defaultModes[mode] || mode] = mode;
                }
            });
            return prefixModes;
        } else {
            return User.defaultModeLetters;
        }
    },
    makeUserFromTarget: function (bid, target) {
        return new User({
            nick: target.nick,
            usermask: target.hostmask,
            ident_prefix: target.ident_prefix,
            user: target.from_name,
            userhost: target.from_host,
            mode: target.from_mode,
            account: target.from_account,
            realname: target.from_realname,
            avatar: target.avatar,
            avatar_url: target.avatar_url,
            display_name: target.display_name,
            bot_url: target.bot_url
        }, {
            session: this.session,
            connection: this,
            buffer: this.getBuffer(bid)
        });
    },
    findBuffer: function (name, exact) {
        return this.buffers.lookup(name, exact);
    },
    findConversation: function (name, exact) {
        var buf = this.findBuffer(name, exact);
        if (buf && buf.isConversation()) {
            return buf;
        }
    },
    findChannel: function (name, exact) {
        var buf = this.findBuffer(name, exact);
        if (buf && buf.isChannel()) {
            return buf;
        }
    },
    getOrMakeBuffer: function (name, exact) {
        return this.findBuffer(name, exact) || this.makeChild({name: name});
    },
    openNewBuffer: function (name) {
        // Open a new buffer
        this.setFocusOnMakeBuffer(name);
        var buffer = this.makeChild({name: name});
        buffer.open();
        return buffer;
    },
    openBuffer: function (name, exact) {
        var buffer = this.findBuffer(name, exact);
        if (buffer) {
            buffer.select();
            return buffer;
        } else {
            return this.openNewBuffer(name);
        }
    },
    joinChannel: function (name, key) {
        return this.post('join', {
            channel: name,
            key: key
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    },
    remove: function (cid) {
        return this.post('delete-connection', {}, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    },
    edit: function (data, callback) {
        return this.post("edit-server", data, callback);
    },
    editName: function (netName, callback) {
        return this.post('set-netname', {
            netname: netName
        }, callback);
    },
    nickservRegisterHelp: function (callback) {
        return this.post("ns-help-register", {}, callback);
    },
    setNickservPassword: function (nsPass, callback) {
        this.set({'nickserv_pass': nsPass});
        return this.post("set-nspass", {
            nspass: nsPass
        }, _.bind(function (response) {
            if (callback) {
                callback(response);
            }
        }, this));
    },
    disconnect: function (cid, message) {
        return this.post('disconnect', {
            msg: message
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    },
    reconnect: function (cid) {
        return this.post('reconnect', {}, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    },
    ignore: function (mask, callback) {
        this.post('ignore', {
            mask: mask
        }, callback);
    },
    unignore: function (mask, callback) {
        this.post('unignore', {
            mask: mask
        }, callback);
    },

    setAway: function (msg) {
        this.propagateUserProps(
            this.getNick(), {away: msg}, true
        );
    },
    setBack: function () {
        this.propagateUserProps(
            this.getNick(), {away: false}, true
        );
    },
    isCollapsed: function () {
        if (!this.serverLog) {
            return false;
        }
        return this.serverLog.isArchived();
    },
    setCollapsed: function () {
        this.serverLog.archive();
    },
    setExpanded: function () {
        this.serverLog.unarchive();
    },
    toggleCollapsed: function () {
        if (this.isCollapsed()) {
            this.setExpanded();
        } else {
            this.setCollapsed();
        }
    },
    away: function (message, callback) {
        this.post('away', {
            msg: message
        }, callback);
    },
    back: function (callback) {
        this.post('back', {}, callback);
    },
    isAway: function () {
        return !!this.get('away');
    },
    setISupport: function (params) {
        for (var k in params) {
            this.isupport[k] = params[k];
        }
        this.trigger('iSupportChange', this);
    },
    getISupport: function (key, fallback) {
        if (key) {
            return this.isupport[key] || fallback;
        }
        return this.isupport;
    },
    getCapValue: function (key) {
        var values = this.get('cap_values') || {};
        return values[key];
    },
    getRelayMsgSeparator: function () {
        return this.getCapValue('draft/relaymsg');
    },
    setUsermodes: function (modes) {
        this.usermodes = modes;
    },
    setVersion: function (version) {
        this.version = version;
    },
    getChannelPrefixes: function () {
        var defaultChanTypes = '#＃';
        var chantypes = this.getISupport('CHANTYPES', defaultChanTypes);
        // In case the isupport value is empty and has been parsed as a flag
        if (chantypes === true) {
            return defaultChanTypes;
        }
        return chantypes;
    },

    // Extra info about servers can be in myinfo and version
    // but we only store it in the backlog, not the conn record (unlike isupport)
    setMyInfo: function (params) {
        this.myinfo = params;
        this.trigger('myInfoChange', this);
    },
    getMyInfo: function (key) {
        if (key) {
            return this.myinfo[key];
        }
        return this.myinfo;
    },

    getFailInfo: function (key) {
        var failInfo = this.get('fail_info');
        if (failInfo && key) {
            return failInfo[key];
        } else {
            return failInfo;
        }
    },
    previousFailInfo: function (key) {
        var failInfo = this.previous('fail_info');
        if (failInfo && key) {
            return failInfo[key];
        } else {
            return failInfo;
        }
    },
    isFailed: function () {
        return !$.isEmptyObject(this.getFailInfo()) && !this.isStatus('ip_retry') && this.getFailInfo('reason') != 'reconnecting' && !this.getFailInfo('ip');
    },
    isSSLVerifyError: function () {
        return this.getFailInfo('reason') == 'ssl_verify_error';
    },
    wasFailed: function () {
        return !$.isEmptyObject(this.previousFailInfo()) && !this.wasStatus('ip_retry') && this.previousFailInfo('reason') != 'reconnecting';
    },
    getStatus: function () {
        return this.get('status');
    },
    isStatus: function (status) {
        return this.getStatus() === status;
    },
    wasStatus: function (status) {
        return this.previous('status') === status;
    },
    isConnected: function () {
        return this.isStatus('connected_ready');
    },
    wasConnected: function () {
        return this.wasStatus('connected_ready');
    },
    isDisconnected: function () {
        return this.isStatus('disconnected') || this.isStatus('undefined') || this.badRetry();
    },
    wasDisconnected: function () {
        return this.wasStatus('disconnected') || this.wasStatus('undefined') || this.wasBadRetry();
    },
    getRetryTimeout: function () {
        if (!this.isFailed()) {
            return;
        }
        var failInfo = this.getFailInfo();
        var ts = this.session.backend.tsOffset((failInfo.timestamp + failInfo.retry_timeout) * 1000);
        return new Date(ts);
    },
    previousRetryTimeout: function () {
        if (!this.wasFailed()) {
            return;
        }
        var failInfo = this.previousFailInfo();
        var ts = this.session.backend.tsOffset((failInfo.timestamp + failInfo.retry_timeout) * 1000);
        return new Date(ts);
    },
    badRetry: function () {
        return this.isStatus('waiting_to_retry') && !this.willRetry();
    },
    wasBadRetry: function () {
        return this.wasStatus('waiting_to_retry') && !this.willHaveRetried();
    },
    willRetry: function () {
        var timeout = this.getRetryTimeout();
        if (timeout) {
            return timeout.getElapsed() < 1;
        }
        return false;
    },
    willHaveRetried: function () {
        var timeout = this.previousRetryTimeout();
        if (timeout) {
            return timeout.getElapsed() < 1;
        }
        return false;
    },
    isConnecting: function () {
        if (this.isStatus('waiting_to_retry')) {
            return this.willRetry();
        }
        return !this.isConnected() && !this.isDisconnected() && !this.isStatus('quitting');
    },
    wasConnecting: function () {
        if (this.wasStatus('waiting_to_retry')) {
            return this.willHaveRetried();
        }
        return !this.wasConnected() && !this.wasDisconnected() && !this.wasStatus('quitting');
    },
    isReady: function () {
        return this.isConnected() || this.isStatus('connected_joining');
    },
    wasReady: function () {
        return this.wasConnected() || this.wasStatus('connected_joining');
    },
    isSocketActive: function () {
        return this.isReady() || this.isStatus('connected');
    },
    wasSocketActive: function () {
        return this.wasReady() || this.wasStatus('connected');
    },
    isActive: function () {
        return this.isSocketActive() || this.isStatus('connecting') || this.isStatus('queued');
    },
    wasActive: function () {
        return this.wasSocketActive() || this.wasStatus('connecting') || this.wasStatus('queued');
    },
    isInactive: function () {
        return this.isDisconnected() || this.isStatus('quitting');
    },
    wasInactive: function () {
        return this.wasDisconnected() || this.wasStatus('quitting');
    }
}), {

    joinUrlParts: function (initial, parts) {
        return _.reduce(parts, function (memo, part) {
            return Connection.joinUrlPart(memo, part);
        }, initial);
    },
    joinUrlPart: function (rootLabel, label) {
        var url = rootLabel;
        if (label) {
            url += '/' + encodeURIComponent(label);
        }
        return url;
    },
    buildUrl: function (rootLabel, parts) {
        return '/irc/' + Connection.joinUrlParts(rootLabel, parts);
    },
    buildLegacyUrl: function (rootLabel, label) {
        return 'irc/' + Connection.joinUrlPart(rootLabel, label);
    },
    buildId: function (rootLabel, label) {
        var id = rootLabel;
        if (label) {
            id += '/' + label;
        }
        return id;
    },
    whitelist: [
        "irc.irccloud.com"
    ],
    defaultPort: 6667,
    defaultSSLPort: 6697
});


module.exports = Connection;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/connection.js
// module id = LLdI
// module chunks = 1